// extracted by mini-css-extract-plugin
export default {"websiteLink":"meGNzcfQKgVDoygPMzTe","linkError":"Ahy07e3917Tl5Ij9hkYh","noBorder":"dQQkJZDjtWdG0vhUv50I"};